import { render, staticRenderFns } from "./BlockType103.vue?vue&type=template&id=20096d84&"
import script from "./BlockType103.vue?vue&type=script&lang=ts&"
export * from "./BlockType103.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports